// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__37ias","content":"styles_content__2Nhme","row":"styles_row__3N8jc","footer":"styles_footer__22gy7","phraseLength":"styles_phraseLength__jpG0Q"};